<vs-badge
  class="!flex w-auto h-5"
  tooltipStyle="light"
  tooltipOpenDelay="350"
  [theme]="status.theme"
  [config]="{ displayStatusIcon: true }"
  [vsTooltip]="processors.length && !hideTooltip ? { template: tooltip } : undefined"
>
  <span id="badge-label">{{ status.text }}</span>
</vs-badge>

<ng-template #tooltip>
  <div class="max-w-[80vw] sm:max-w-xs max-h-[224px] overflow-hidden">
    <p class="text-xs font-semibold text-gray-700 mb-2">Processes run on this document</p>
    <div class="scrollbar-thin overflow-auto flex flex-wrap gap-1">
      <div
        *ngFor="let processor of processors"
        class="flex-grow overflow-hidden border border-gray-300 flex items-center gap-1 py-1 pl-1.5 pr-2 rounded-md"
      >
        <vs-icon
          size="8"
          name="circle"
          type="solid"
          class="self-center text-themed-500"
          [theme]="processor.theme"
        ></vs-icon>

        <div class="truncate text-xs text-gray-700">
          {{ processor.label }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
